import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { useLocalSearchParams, useRouter } from 'expo-router'
import React from 'react'
import { ms, ScaledSheet } from 'react-native-size-matters'
import { FormButton } from '~components/FormButton'
import ModalScreen, { getModalStyleDefinition, ModalFooter } from '~components/ModalScreen'
import { Text, View } from '~components/Themed'
import { useTheme } from '~theme/ThemeManager'

export default function PermissionDeniedScreen(): React.JSX.Element {
  const { theme } = useTheme()
  const styles = useStyles()
  const router = useRouter()
  const { message } = useLocalSearchParams<{ message?: string }>()

  return (
    <ModalScreen
      Footer={
        <ModalFooter>
          <View></View>
          {router.canDismiss() && (
            <FormButton onPress={() => router.dismiss()} title={'Close'} style={styles.button} />
          )}
          <View></View>
        </ModalFooter>
      }
    >
      <View style={styles.inner}>
        <View style={[styles.content, styles.contentCenter]}>
          <FontAwesomeIcon
            icon={['fal', 'lock-alt']}
            size={ms(53)}
            color={theme[400]}
            style={styles.button}
          />

          <View style={styles.titleContainer}>
            <Text style={styles.title}>Permission Denied</Text>
            {/* TODO: Should be stored in state not via URL */}
            {message && <Text style={styles.subtitle}>{message}</Text>}
          </View>
        </View>
      </View>
    </ModalScreen>
  )
}

const useStyles = () => {
  const { theme, mode } = useTheme()
  return ScaledSheet.create({
    ...getModalStyleDefinition(theme, mode),
    button: {
      alignSelf: 'center',
    },
    contentCenter: {
      justifyContent: 'center',
    },
  })
}
